import React, { useState, useEffect } from 'react';
import {
  Smartphone, MessageSquare, Wifi, ArrowUpDown, RotateCcw,
  X, Plus, Wallet, Users, RefreshCw
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

const QuickActionMenu = ({ onAction }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const actions = [
    { id: 'topup', label: t('quickActions.topup'), icon: Smartphone, color: 'bg-blue-500' },
    { id: 'social', label: t('quickActions.social'), icon: MessageSquare, color: 'bg-purple-500' },
    { id: 'bundle', label: t('quickActions.bundle'), icon: Wifi, color: 'bg-green-500' },
    { id: 'transfer', label: t('quickActions.transfer'), icon: ArrowUpDown, color: 'bg-orange-500' },
    { id: 'reverse', label: t('quickActions.reverse'), icon: RotateCcw, color: 'bg-red-500' },
  ];

  useEffect(() => {
    if (isOpen) {
      setShowMenu(true);
    } else {
      const timer = setTimeout(() => setShowMenu(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div 
        className={`mb-4 transition-all duration-300 ${
          isOpen 
            ? 'opacity-100 translate-y-0 pointer-events-auto' 
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-md rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 p-3">
          <div className="flex items-center gap-3">
            {actions.map((action, index) => (
              <button
                key={action.id}
                onClick={() => {
                  onAction(action.id);
                  setIsOpen(false);
                }}
                className="flex flex-col items-center group"
                style={{ 
                  transitionDelay: isOpen ? `${index * 50}ms` : '0ms',
                  opacity: isOpen ? 1 : 0,
                  transform: isOpen ? 'scale(1)' : 'scale(0.9)'
                }}
              >
                <div className={`
                  p-3 rounded-xl ${action.color} 
                  text-white shadow-lg group-hover:shadow-xl 
                  transition-all duration-300
                  group-hover:scale-110 group-hover:-translate-y-1
                  w-12 h-12 flex items-center justify-center
                `}>
                  <action.icon size={22} />
                </div>
                <span className="text-xs mt-2 font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
                  {action.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          bg-gradient-to-r from-[#CD0C02] to-[#a80101] 
          text-white rounded-full px-4 py-4 shadow-lg 
          flex items-center gap-3 mx-auto
          transition-all duration-300 transform
          hover:shadow-xl hover:scale-105
          active:scale-95
          font-semibold text-lg
          ${isOpen ? 'ring-4 ring-red-300 dark:ring-red-900/50' : ''}
        `}
      >
        <div className={`transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`}>
          {isOpen ? <X size={24} /> : <Plus size={24} />}
        </div>
      </button>
    </div>
  );
};

export default QuickActionMenu;